import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiFillFileText } from "react-icons/ai";

import courseServices from "../../../services/courseServices";
import Button from "../../Button";
import LoadingSpinner from "../../LoadingSpinner";
import Modal from "../../Modal";

const ExtraResourcesModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [resources, setResources] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal(selectedCourseID) {
      setIsOpen(true);
      fetchResources(selectedCourseID);
    },
    closeModal() {
      setIsOpen(false);
      setResources([]);
    },
  }));

  const handleCloseModal = () => {
    setResources([]);
    setIsOpen(false);
  };

  const fetchResources = async (courseID) => {
    setIsLoading(true);
    try {
      const response = await courseServices.getCourseResources(courseID); // Replace with actual API method
      setResources(response || []);
    } catch (error) {
      console.error("Error fetching extra resources:", error);
      setResources([]);
    }
    setIsLoading(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      {isLoading ? (
        <div className="flex items-center justify-center py-2">
          <LoadingSpinner color="green" />
        </div>
      ) : resources.length > 0 ? (
        <div className="space-y-4">
          {resources.map((res, index) => (
            <a href={res.url} target="_blank" rel="noopener noreferrer">
              <div key={index} className="mb-2 flex items-center justify-between gap-4 p-2">
                <div className="flex items-center gap-3">
                  <span className="text-sm font-medium text-mutedText underline dark:text-dark-mutedText">
                    {res.name}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      ) : (
        <p className="flex min-h-[45vh] items-center justify-center text-center text-gray-500">
          {t("no_resources_available")}
        </p>
      )}
    </Modal>
  );
});

export default ExtraResourcesModal;
